import { DataList, DataListItemProps } from '@components/patterns/DataList';

import css from './styles.module.css';

export type PrettyJSONFieldProps = Pick<
  DataListItemProps,
  'children' | 'label' | 'variant' | 'copy'
>;

export function PrettyJSONField({
  children,
  label,
  variant,
  copy,
}: PrettyJSONFieldProps) {
  return (
    <DataList.Item
      className={css.field}
      label={label}
      variant={variant}
      copy={copy}
    >
      {children}
    </DataList.Item>
  );
}
